import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { groupItemsByType } from '../../../../utils/webCvUtils';
import sty from '../../WebCv/WebCv.module.css';
import ProjectsGanttChart from '../WebCvGraph/ProjectsGanttChart';

const Projects = ({ data }) => {
    Projects.propTypes = {
        data: PropTypes.array.isRequired,
    };

    // 表示・非表示の切り替え
    const [visibleStates, setVisibleStates] = useState(
      data && Array.isArray(data) && data.length === 1 ? [true] : []
    );

    const [sortedData, setSortedData] = useState([]);
    
    // プロジェクトの開始日を比較して、降順にソートする
    useEffect(() => {
        if (data && data.length > 0) {
            // 開始日に基づいてデータをソート
            let sorted = [...data].sort((a, b) => {
                // 終了日が空（現在進行中）のプロジェクトを優先
                const aIsOngoing = a.end_year === '' && a.end_month === '';
                const bIsOngoing = b.end_year === '' && b.end_month === '';
                
                if (aIsOngoing && !bIsOngoing) return -1; // aが進行中、bが終了済み
                if (!aIsOngoing && bIsOngoing) return 1;  // aが終了済み、bが進行中
                
                // 両方とも進行中または両方とも終了済みの場合
                
                // 終了年の比較
                const endYearA = aIsOngoing ? new Date().getFullYear() : parseInt(a.end_year);
                const endYearB = bIsOngoing ? new Date().getFullYear() : parseInt(b.end_year);
                
                if (endYearB !== endYearA) {
                    return endYearB - endYearA; // 終了年の降順
                }
                
                // 終了月の比較
                const endMonthA = aIsOngoing ? new Date().getMonth() + 1 : parseInt(a.end_month);
                const endMonthB = bIsOngoing ? new Date().getMonth() + 1 : parseInt(b.end_month);
                
                if (endMonthB !== endMonthA) {
                    return endMonthB - endMonthA; // 終了月の降順
                }
                
                // 終了日が同じ場合は開始日で比較（最新が前に）
                // 開始年の比較
                const startYearA = parseInt(a.start_year);
                const startYearB = parseInt(b.start_year);
                
                if (startYearB !== startYearA) {
                    return startYearB - startYearA; // 開始年の降順
                }
                
                // 開始月の比較
                const startMonthA = parseInt(a.start_month);
                const startMonthB = parseInt(b.start_month);
                
                if (startMonthB !== startMonthA) {
                    return startMonthB - startMonthA; // 開始月の降順
                }
                
                // 開始日も終了日も同じ場合は、created_atの降順でソート
                if (a.created_at && b.created_at) {
                    const createdAtA = new Date(a.created_at);
                    const createdAtB = new Date(b.created_at);
                    return createdAtB - createdAtA; // created_atの降順
                }
                
                // created_atがない場合は順序を維持
                return 0;
            });
            let count = 0;
            for(let i = sorted.length; i> 0; i--){
                sorted[count]['projectNum'] = i;
                count++;
            }
            setSortedData(sorted);
        } else {
            setSortedData([]);
        }
    }, [data]);

    if (!sortedData || sortedData.length === 0) {
      return <div>プロジェクトデータがありません</div>;
    }

    // 表示チェック
    const checkOpen = (id) => {
        if (id === 1) {
            return 'open';
        }
    }
    const setProjectDate = (endYear, endMonth) => {
        let endDay = '';
        // 月によって日数を調整
        if (endMonth) {
            const month = parseInt(endMonth);
            // 月末日を設定
            switch (month) {
                case 2: // 2月
                    // うるう年の考慮（簡易版）
                    if (endYear && parseInt(endYear) % 4 === 0) {
                        endDay = '29';
                    } else {
                        endDay = '28';
                    }
                    break;
                case 4: case 6: case 9: case 11: // 30日の月
                    endDay = '30';
                    break;
                default: // 31日の月
                    endDay = '31';
                    break;
            }
        }
        if(endYear === '' && endMonth === '') {
            return `現在`;
        } else {
            return `${endYear}/${endMonth}/${endDay}`;
        }
    }
    function setPeriod(startYear, startMonth, endYear, endMonth) {
      // 合計月数の計算
      if (endYear === '' && endMonth === '') {
        const currentDate = new Date();
        endYear = currentDate.getFullYear();
        endMonth = currentDate.getMonth() + 1; // JavaScriptの月は0から始まるため+1
      }
      const totalMonths = (parseInt(endYear) - parseInt(startYear)) * 12 + (parseInt(endMonth) - parseInt(startMonth)) + 1;
      
      // 合計月数を年月に変換
      const years = Math.floor(totalMonths / 12);
      const months = totalMonths % 12;
      
      let label = '';
      
      if (years >= 1) {
        // 1年以上の場合
        if (months > 0) {
            label = `${years}年${months}か月`;
        } else {
            label = `${years}年`;
        }
      } else if (months > 0) {
          // 1年未満の場合
          label = `${months}か月`;
      } else {
          label = '1か月未満';
      }
      return label;
    }
    
    const checkProcess = (process) => {
        if (process) {
            return '■';
        } else {
            return '□';
        }
    }

    const toggleVisibility = (projectIndex) => {
        const newVisibleStates = [...visibleStates];
        newVisibleStates[projectIndex] = !newVisibleStates[projectIndex]; // 非表示は表示、表示は非表示に切り替える
        setVisibleStates(newVisibleStates);
    };

    const toggleVisibilityForGantt = (projectIndex) => {
      // プロジェクト表示済みの場合は何もしない
      if(visibleStates[projectIndex]){
        return
      }
      const newVisibleStates = [...visibleStates];
      newVisibleStates[projectIndex] = !newVisibleStates[projectIndex];
      setVisibleStates(newVisibleStates);
  };
  
    return (
        <div className={sty['cv__pj_outer']}>
            <div className={sty['cv__pj_terms-graph']}>
                <ProjectsGanttChart data={sortedData} toggleVisibilityForGantt={toggleVisibilityForGantt} />
            </div>
            {sortedData.map((projects, projectIndex) => (
                <div className={sty['cv__projects-details']} open={checkOpen(projects.project_id)} key={projects.project_id}>
                    <div className={sty['cv__pj-flex']}>
                        <div className={sty['cv__pj-term']}>
                            <span className={sty['cv__projects-circle']}></span>
                            <span className={sty['cv__projects-txt']}>
                                {projects.start_year}/{projects.start_month}/1<br className={sty['pc']} /> ~ {setProjectDate(projects.end_year, projects.end_month)}
                                ({setPeriod(projects.start_year, projects.start_month, projects.end_year, projects.end_month)})
                            </span>
                        </div>
                        <div className={sty['cv__pj-details']}>
                            <p type="button" className={sty['cv__pj-visible']} onClick={() => toggleVisibility(projects['projectNum'])}>
                                {visibleStates[projects['projectNum']] ? '▲非表示' : '▼表示'}
                            </p>
                            <div className={sty['cv__projects-tit']} onClick={() => toggleVisibility(projects['projectNum'])}>
                                <p className={sty['cv__projects-tit--line']} data-project={`${projects['projectNum']}_${projects.project_name}`}>
                                  {`${projects['projectNum']}.${projects.project_name}`}
                                </p>
                                <div className={sty['cv__pj-summary']}>
                                    <div className={sty['cv__pj-summary-item']}>PJ区分:{projects.project_category}</div>
                                    <div className={sty['cv__pj-summary-item']}>業種:{projects.industry}</div>
                                    <div className={sty['cv__pj-summary-item']}>役割:{projects.role}</div>
                                    <div className={sty['cv__pj-summary-item']}>規模:{projects.scale}</div>
                                </div>
                            </div>
                            {visibleStates[projects['projectNum']] && (
                                <>
                                    <div className={sty['cv__projects-list']}>
                                        {projects.overview}
                                    </div>


                                    <dl className={sty['cv__projects-list']}>
                                        <dt className={sty['cv__projects-list-tit']}>担当工程</dt>
                                        <dd className={sty['cv__projects-list-txts']}>
                                            <div className={`${sty['cv__projects-table-wrap']} ${sty['cv__pj-table-wrap-process']}`}>
                                                <table className={`${sty['cv__projects-table']} ${sty['cv__projects-table--itinerary']}`}>
                                                    <thead>
                                                        <tr>
                                                            <th>要件定義</th>
                                                            <th>基本設計</th>
                                                            <th>詳細設計</th>
                                                            <th>実装・構築</th>
                                                            <th>単体テスト</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{checkProcess(projects.process?.requirement_analysis)}</td>
                                                            <td>{checkProcess(projects.process?.basic_design)}</td>
                                                            <td>{checkProcess(projects.process?.detailed_design)}</td>
                                                            <td>{checkProcess(projects.process?.coding)}</td>
                                                            <td>{checkProcess(projects.process?.unit_test)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table className={`${sty['cv__projects-table']} ${sty['cv__projects-table--itinerary']}`}>
                                                    <thead>
                                                        <tr>
                                                            <th>結合テスト</th>
                                                            <th>総合テスト</th>
                                                            <th>負荷テスト</th>
                                                            <th>セキュリティ<br />テスト</th>
                                                            <th>保守・運用</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{checkProcess(projects.process?.integration_test)}</td>
                                                            <td>{checkProcess(projects.process?.system_test)}</td>
                                                            <td>{checkProcess(projects.process?.load_test)}</td>
                                                            <td>{checkProcess(projects.process?.security_test)}</td>
                                                            <td>{checkProcess(projects.process?.operation)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </dd>
                                    </dl>
                                    <dl className={sty['cv__projects-list']}>
                                        <dt className={sty['cv__projects-list-tit']}>システム/作業環境</dt>
                                        <dd className={sty['cv__projects-list-txts']}>
                                            <div className={sty['cv__projects-table-wrap']}>
                                                {/* サーバーテーブル */}
                                                {projects.server && projects.server.length > 0 && Object.keys(groupItemsByType(projects.server, 'server_type', 'server_con')).length > 0 && (
                                                  <table className={`${sty['cv__projects-table']} ${sty['cv__projects-table--system']}`}>
                                                    <thead>
                                                      <tr>
                                                        <th colSpan={2}>サーバー</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {Object.entries(groupItemsByType(projects.server, 'server_type', 'server_con')).map(([type, connections]) => (
                                                        <tr key={type}> 
                                                          <td>{type}</td>  
                                                          <td>{connections.join(", ")}</td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                )}

                                                {/* クライアントテーブル */}
                                                {projects.client && projects.client.length > 0 && Object.keys(groupItemsByType(projects.client, 'client_type', 'client_con')).length > 0 && (
                                                  <table className={`${sty['cv__projects-table']} ${sty['cv__projects-table--system']}`}>
                                                    <thead>
                                                      <tr>
                                                        <th colSpan={2}>クライアント</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {Object.entries(groupItemsByType(projects.client, 'client_type', 'client_con')).map(([type, connections]) => (
                                                        <tr key={type}> 
                                                          <td>{type}</td>  
                                                          <td>{connections.join(", ")}</td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                )}

                                                {/* 開発テーブル */}
                                                {projects.dev && projects.dev.length > 0 && Object.keys(groupItemsByType(projects.dev, 'dev_type', 'dev_con')).length > 0 && (
                                                  <table className={`${sty['cv__projects-table']} ${sty['cv__projects-table--system']}`}>
                                                    <thead>
                                                      <tr>
                                                        <th colSpan={2}>開発</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {Object.entries(groupItemsByType(projects.dev, 'dev_type', 'dev_con')).map(([type, connections]) => (
                                                        <tr key={type}> 
                                                          <td>{type}</td>  
                                                          <td>{connections.join(", ")}</td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                )}

                                                {/* クラウドテーブル */}
                                                {projects.cloud && projects.cloud.length > 0 && Object.keys(groupItemsByType(projects.cloud, 'cloud_type', 'cloud_con')).length > 0 && (
                                                  <table className={`${sty['cv__projects-table']} ${sty['cv__projects-table--system']}`}>
                                                    <thead>
                                                      <tr>
                                                        <th colSpan={2}>クラウド</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {Object.entries(groupItemsByType(projects.cloud, 'cloud_type', 'cloud_con')).map(([type, connections]) => (
                                                        <tr key={type}> 
                                                          <td>{type}</td>  
                                                          <td>{connections.join(", ")}</td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                )}

                                                {/* 作業PCテーブル */}
                                                {projects.pc && projects.pc.length > 0 && Object.keys(groupItemsByType(projects.pc, 'pc_type', 'pc_con')).length > 0 && (
                                                  <table className={`${sty['cv__projects-table']} ${sty['cv__projects-table--system']}`}>
                                                    <thead>
                                                      <tr>
                                                        <th colSpan={2}>作業PC</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {Object.entries(groupItemsByType(projects.pc, 'pc_type', 'pc_con')).map(([type, connections]) => (
                                                        <tr key={type}> 
                                                          <td>{type}</td>  
                                                          <td>{connections.join(", ")}</td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                )}

                                                {/* ネットワークテーブル */}
                                                {projects.network && projects.network.length > 0 && Object.keys(groupItemsByType(projects.network, 'network_type', 'network_con')).length > 0 && (
                                                  <table className={`${sty['cv__projects-table']} ${sty['cv__projects-table--system']}`}>
                                                    <thead>
                                                      <tr>
                                                        <th colSpan={2}>ネットワーク</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {Object.entries(groupItemsByType(projects.network, 'network_type', 'network_con')).map(([type, connections]) => (
                                                        <tr key={type}> 
                                                          <td>{type}</td>  
                                                          <td>{connections.join(", ")}</td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                )}
                                            </div>
                                        </dd>
                                    </dl>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Projects;